<template>
    <div>
        <app-bar style="top: 0; z-index: 10; width: 100%;" @onBack="handleBackEvent">
            <span style="display: inline-block; font-weight: bold; font-size: 18px; color: #3c3c3c; padding-top: 16px;">한눈에 보는 육아 지원금</span>
            <!--<div>한눈에 보는 육아 지원금</div>-->
        </app-bar>

        <div class="container">
            <div class="content-container">
                <div class="content-title">{{info.title}}</div>
                <div style="margin-top: 8px; font-weight: 400">{{info.name}}</div>

                <div style="margin-top: 20px;">
                    <el-tag class="tag-item"
                            v-for="(item, idx) in tags"
                            :key="idx"
                            effect="dark">
                        {{ item }}
                    </el-tag>
                </div>
            </div>

            <div class="content-container top-border">
                <div class="detail-content-title">조건</div>
                <div class="multiple" v-html="info.detail_condition"></div>
            </div>

            <div class="content-container top-border">
                <div class="detail-content-title">혜택</div>
                <div class="multiple" v-html="info.detail_benefit"></div>
            </div>

            <div class="content-container top-border">
                <div class="detail-content-title">신청방법</div>
                <div class="multiple" v-html="info.detail_how_apply"></div>
            </div>

            <div class="content-container top-border">
                <div class="detail-content-title">필요서류</div>
                <div class="multiple" v-html="info.detail_required_document"></div>
            </div>

            <div class="content-container top-border">
                <div class="detail-content-title">기타</div>
                <div class="multiple" v-html="info.detail_etc"></div>
            </div>
        </div>

        <div style="font-weight: 600; font-size: 13px; float: right; margin-right: 16px; ">
            <div v-if="ts != registered_ts" style="margin-bottom: 6px;">
                수정일 : {{ts}}
            </div>
            <div style="margin-bottom: 16px;">
                작성일 : {{registered_ts}}
            </div>
        </div>

        <!--<transition name="slide-fade">-->
            <div
                    style="position: fixed; right: 0; bottom: 40px; margin-right: 20px; cursor: pointer"
                    v-if="info.link" :href="info.link" @click="openApply">

                <div style="display: table; justify-items: center; position: relative; float:left; height: 100%; margin-top: 12px; margin-right: 10px; padding: 6px; font-size: 12px; background: RGBA(51,51,51,80); font-weight: 600; color: #d4d4d4; border-radius: 6px;">
                    홈페이지 바로 가기
                </div>
                <div id="oval-link">
                    <img src="../../assets/ic_url.svg" class="icon" style="width: 26px; height: 26px; margin-top: 10px;"/>
                </div>

            </div>
        <!--</transition>-->

    </div>
</template>

<script>

    import appBar from "@/components/common/app_bar";
    import firebase from "firebase/app";
    import 'firebase/analytics'

    const {getInfo} = require('../../Api');

    export default {
        name: "information_detail",
        components: {
            appBar
        },
        data() {
            return {
                info: undefined,
                sidx: this.$route.params.sidx,
                controlShow: true,
                openTelVisible: false,
                tags: [],
                ts: '',
                registered_ts: ''
            }
        },
        beforeMount() {
            this.getInfo(this.sidx);
            window.addEventListener('scroll', this.handleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            getTs() {
                let date = new Date();

                let year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();

                if (month < 10) {
                    month = "0" + month
                }

                if (day < 10) {
                    day = "0" + day
                }

                if (hour < 10) {
                    hour = "0" + hour
                }

                if (minutes < 10) {
                    minutes = "0" + minutes
                }

                if (seconds < 10) {
                    seconds = "0" + seconds
                }

                return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
            },
            initTags() {

                if (this.info.child_birth != 0) {
                    var birth = null;
                    let months = parseInt(this.info.child_birth);

                    if (months > 12) {
                        let year = parseInt(months / 12);
                        let new_month = months - (year * 12);

                        if (new_month != 0) {
                            birth = `${year}년 ${new_month}개월`;
                        } else {
                            birth = `${year}년`;
                        }
                    } else {
                        birth = `${months}개월`;
                    }


                    if (this.childbirth_type == 0) {
                        this.tags.push(`임신 후 ${birth} 이내`)
                    } else {
                        this.tags.push(`출산 후 ${birth} 이내`)
                    }
                }

                if (this.info.income != 0) {
                    if (this.income_type == 0) {
                        this.tags.push(`월 수입 ${parseInt(this.info.income).toLocaleString()}원 이하`)
                    } else {
                        this.tags.push(`건강보험료 ${parseInt(this.info.income).toLocaleString()}원 이하`)
                    }
                }

                if (this.info.apply_online == 0) {
                    this.tags.push(`현장 신청가능`)
                } else if (this.info.apply_online == 1) {
                    this.tags.push(`온라인 신청가능`)
                } else {
                    this.tags.push(`온라인/현장 신청가능`)
                }

                if (this.info.require_card == 1) {
                    this.tags.push(`지원카드 필요`)
                }

                if (this.info.multi_cultural == 1) {
                    this.tags.push(`다문화 자녀`)
                }

                if (this.info.disabled == 1) {
                    this.tags.push(`장애여부`)
                }

                if (this.info.second_tier == 1) {
                    this.tags.push(`차상위 계층`)
                }

                if (this.info.basic_income == 1) {
                    this.tags.push(`기초수급`)
                }

                if (this.info.one_parent == 1) {
                    this.tags.push(`한부모 가정`)
                }
            },
            handleBackEvent() {
                this.$router.go(-1)
            },
            async getInfo(sidx) {
                let response = await getInfo(sidx)

                if (response.data.res == 0) {
                    this.info = response.data.data;

                    this.initTags();
                    this.ts = this.info.ts.substring(0, this.info.ts.length - 3);
                    this.registered_ts = this.info.registered_ts.substring(0, this.info.registered_ts.length - 3);
                }
            },
            handleScroll() {
                var currentScroll = window.scrollY;
                var containerHeight = document.documentElement.scrollHeight - window.innerHeight;

                if (currentScroll == containerHeight) {
                    this.controlShow = true;
                    this.previousScroll = currentScroll;
                    return;
                }

                if (currentScroll < (this.previousScroll - 5)) {
                    this.controlShow = true;
                } else if (currentScroll > (this.previousScroll + 5)) {
                    this.controlShow = false;
                }

                this.previousScroll = currentScroll;
            },
            openApply() {

                firebase.analytics().logEvent('clickGoHomepage', {
                    ts : this.getTs()
                });

                let userAgent = navigator.userAgent;


                if (confirm(`확인 버튼을 누르면 ${this.info.name} 홈페이지로 이동돼요.`)) {

                    if (userAgent.match('mobile_user')) {
                        if (userAgent.match('Android')) {
                            window.Dorbom.postMessage(this.info.link);
                        } else if (userAgent.match('iPhone|iPad|iPod')) {
                            window.webkit.messageHandlers.callBackHandler.postMessage(this.info.link);
                        }
                    } else {
                        window.location.href = this.info.link;
                    }
                }
            }
        }
    }
</script>

<style>

    html, body {
        width: 100%;
        margin: 0 auto;
        padding: 0 auto;
        background-color: #f8f8f8;
    }

    ul {

    }

    .container {
        text-align: left;
        padding: 3rem 0 0 0;
    }

    .content-title {
        font-weight: bold;
        font-size: 28px;
    }

    .content-container {
        margin: 0 0 12px 0;
        background-color: white;
        padding: 30px 8px 0px 16px;
        border-bottom: #eeeeee solid 1px;
    }

    .detail-content-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 14px;
        color: #3c3c3c;
    }

    .top-border {
        border-top: #eeeeee solid 1px;
    }

    .multiple {
        white-space: pre-wrap;
        line-height: 20px;
        overflow-x: hidden;
        font-size: 14px;
        color: #3c3c3c;
    }

    .multiple table {
        display: block;
        border-collapse: collapse;
        text-align: center;
        line-height: 1.5;
        overflow: auto;
        padding-bottom: 16px;
    }

    .multiple table > tbody > tr:nth-of-type(1) {
        font-weight: bold;
        border-bottom: 1px solid #ccc;
        background: #f3f6f7;
    }

    .multiple table td {
        min-width: 100px;
    }

    .tag-item {
        margin-right: 8px;
        margin-bottom: 6px;
        color: #3d3d3d;
        background-color: #ffea6d;
        border-color: #ffea6d;
        border-radius: 20px;
        font-weight: 600;
    }

    ul {
        margin-left: 30px;
        padding: 0;
    }

    #oval-link {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffea6d;
        float: left;
        cursor: none;
        display: block;
    }

    #oval-tel {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffde3f;
        float: left;
        cursor: none;
        display: block;
    }

    .slide-fade-enter-active {
        transition: all 0.5s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.5s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0%;
    }

    .icon {
        margin-top: 10px;
        width: 30px;
        height: 30px;
    }
</style>